import { render } from "./MyServices.vue?vue&type=template&id=0f0523b4&scoped=true"
import script from "./MyServices.vue?vue&type=script&lang=js"
export * from "./MyServices.vue?vue&type=script&lang=js"

import "./MyServices.vue?vue&type=style&index=0&id=0f0523b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0523b4"]])

export default __exports__